import type { ThemeName } from "@huub-web/ui";

/**
 * Maps whitelabel theme names to their brand locale prefix.
 *
 * Brand overrides are stored in `<brand>.<locale>.json` files alongside
 * regular `<locale>.json` translation files. At runtime, override keys
 * are merged on top of the base locale via `addResourceBundle`.
 */
export const THEME_TO_BRAND: Partial<Record<ThemeName, string>> = {
  light: "huub",
  dark: "huub",
  asr: "asr",
  verenigingEigenHuis: "veh",
  eviVanLanschot: "evi",
  obvion: "obvion",
  allianz: "allianz",
  fnv: "fnv",
  randstad: "randstad",
  vista: "vista",
  achmea: "achmea",
  funda: "funda",
  nvm: "nvm",
  abnamro: "abnamro",
  domek: "domek",
};
